import { useState, useEffect } from "react";
import { BehaviorSubject } from "rxjs";
import LoadingImage from "../../assets/images/loading.gif";

// handle loading
const loadingSubject = new BehaviorSubject<boolean>(false);

export const toggleLoading = (value: boolean) => {
  loadingSubject.next(value);
};

const LoadingIndicator = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);

  const toggleLoading = (value: boolean) => {
    if (value) {
      setCount((previous) => previous + 1);
    } else {
      setCount((previous) => previous - 1);
    }
  };

  useEffect(() => {
    if (count > 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [count]);

  //#region Subscribe Loading
  useEffect(() => {
    const subscribe = loadingSubject.subscribe((value) => {
      toggleLoading(value);
    });
    return () => {
      subscribe.unsubscribe();
    };
  }, []);
  //#endregion Subscribe Loading

  return isLoading ? (
    <div className="loading-inside-container">
      <div className="loading-container">
        <img className="loading-img" alt="loading" src={LoadingImage} />
      </div>

    </div>
  ) : null;
};

export default LoadingIndicator;
